document.addEventListener('DOMContentLoaded', function() {
  const initWhyChooseSlider = () => {
    const swiperContainer = document.querySelector('.why-choose__slider');
    
    if (swiperContainer) {
      new Swiper(swiperContainer, {
        slidesPerView: 'auto', 
        spaceBetween: 24,      
        grabCursor: true,
        watchOverflow: true,   
        navigation: {
          nextEl: '.why-choose__button.next',
          prevEl: '.why-choose__button.prev',
        },
        breakpoints: {
          1440: {
            slidesPerView: 4,
            allowTouchMove: false 
          }
        }
      });
    }
  };

  initWhyChooseSlider();
});